import { usePurchaseOrdersQuery } from '@/features/purchase-orders/hooks/use-purchase-orders-query';
import { usePurchaseOrdersTableColumns } from '@/features/purchase-orders/hooks/use-purchase-orders-table-columns';
import { useDataTable } from '@/hooks/use-data-table';
import type { PurchaseOrder } from '@/types/core/purchase-order/purchase-order';
import type { ExtendedColumnSort } from '@/types/data-table';

export const defaultSorting: ExtendedColumnSort<PurchaseOrder>[] = [
  { id: 'createdAt', desc: true },
];

export function usePurchaseOrdersTable() {
  const columns = usePurchaseOrdersTableColumns();
  const { purchaseOrders, isPending } = usePurchaseOrdersQuery();

  const dataTable = useDataTable<PurchaseOrder>({
    data: purchaseOrders.data,
    columns,
    pageCount: purchaseOrders.maxPage,
    renderFallbackValue: '-',
    initialState: {
      sorting: defaultSorting,
    },
  });

  return {
    ...dataTable,
    isPending,
  };
}
